import React, { useEffect } from 'react';
import Honeybadger from 'honeybadger-js';
import { useHistory } from 'react-router-dom';
import { useWeddingWebsiteQuery, useBucketRsvpWorkflowMutation } from '../../generated/graphql';
import analyticsPageData from '../../helpers/analyticsPageData';

const InitialLoad: React.FC = () => {
  const { data } = useWeddingWebsiteQuery();
  const [bucketRsvpWorkflowMutation] = useBucketRsvpWorkflowMutation();

  // When CV2 is loaded, we need to call the bucketRSVPWorkflow mutation if rsvpWorkflow is not yet set on their guestwedding.
  useEffect(() => {
    if (data?.guestWedding?.rsvpWorkflow !== null) {
      return;
    }

    const bucket = async () => {
      try {
        await bucketRsvpWorkflowMutation();
      } catch (error) {
        Honeybadger.notify(error, 'Error Calling BucketRSVPWorkflow Mutation');
      }
    };
    bucket();
  }, [data, bucketRsvpWorkflowMutation]);

  const history = useHistory();
  useEffect(() => {
    return history.listen(() => {
      const { category, name, ...rest } = analyticsPageData();

      if (window?.analytics?.page) {
        window.analytics.page(category, name, rest);
      }
    });
  }, [history]);

  return null;
};

export default InitialLoad;
